import ReactApexChart from "react-apexcharts";

const WillingnessToRelocate = (data: any) => {

  if (!data || !data.data) {
    return <div>Error: Unable to load chart data.</div>;
  }

  // Filter valid data entries
  const filteredData = data.data.filter(
    (item: any) => item.count !== null && item.willingness_to_relocate !== null
  );

  if (filteredData.length === 0) {
    return (
      <div id="chart-willingness-relocate">
        <h3>Are you willing to relocate</h3>
        <div>No data available for this chart.</div>
      </div>
    );
  }

  // Sort responses in logical order: Yes, Maybe, No
  const responseOrder = ["yes", "maybe", "no"];
  const sortedData = [...filteredData].sort((a, b) => {
    const aResponse = (a.willingness_to_relocate || "").toLowerCase();
    const bResponse = (b.willingness_to_relocate || "").toLowerCase();

    const aIndex = responseOrder.findIndex((order) =>
      aResponse.includes(order)
    );
    const bIndex = responseOrder.findIndex((order) =>
      bResponse.includes(order)
    );

    // If both found, sort by order
    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
    // If only one found, prioritize the found one
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;
    // Fallback to alphabetical
    return aResponse.localeCompare(bResponse);
  });

  const series = sortedData.map((item: any) => item.count);
  const labels = sortedData.map((item: any) => item.willingness_to_relocate);

  const options = {
    chart: {
      type: "donut" as "donut",
      events: {
        dataPointSelection: (event: any, chartContext: any, config: any) => {
          try {
            if (
              config &&
              config.w &&
              config.w.config &&
              config.w.config.labels &&
              typeof config.dataPointIndex === "number" &&
              config.dataPointIndex >= 0 &&
              config.dataPointIndex < config.w.config.labels.length
            ) {

            } else {
            }
          } catch (error) {
          }
        },
      },
    },
    labels: labels,
    colors: ["#36A2EB", "#FFCE56", "#FF6384"], // Blue for Yes, Yellow for Maybe, Red for No
    legend: {
      position: "bottom" as "bottom",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom" as "bottom",
          },
        },
      },
    ],
  };

  return (
    <div id="chart-willingness-relocate">
      <h3>Are you willing to relocate</h3>
      <ReactApexChart
        options={options}
        series={series}
        type="donut"
        width={380}
      />
    </div>
  );
};

export default WillingnessToRelocate;
